<template>
  <div>
  <IriadeTextarea :label="input.label"
                  :error-messages="errors"
                  v-on="$listeners" :hint="input.config.hint"></IriadeTextarea>
  </div>
</template>

<script>
  import IriadeFormBlockMixin from './IriadeFormBlockMixin'

  export default {
    mixins: [IriadeFormBlockMixin],
  }
</script>
